module.exports = __webpack_public_path__ + "img/modify-bg.bbce0f19.png";